import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=ecd8b53c&"
import script from "./fee.vue?vue&type=script&lang=js&"
export * from "./fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports